var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.23 0H6.77a6.732 6.732 0 0 0-4.787 2.005A6.883 6.883 0 0 0 0 6.845v14.31c0 1.816.713 3.557 1.983 4.84A6.732 6.732 0 0 0 6.769 28h26.462a6.731 6.731 0 0 0 4.786-2.005A6.883 6.883 0 0 0 40 21.155V6.846a6.883 6.883 0 0 0-1.983-4.84A6.731 6.731 0 0 0 33.231 0Zm-5.396 14.274-12 6.222a.304.304 0 0 1-.409-.122.313.313 0 0 1-.04-.152V7.778a.313.313 0 0 1 .149-.264.305.305 0 0 1 .3-.01l12 6.222a.31.31 0 0 1 .167.277.314.314 0 0 1-.167.277v-.006Z",
    fill: "#DDD"
  })));
};

export default SvgYoutube;